module.exports = __webpack_public_path__ + "091eca6f1ff3bae172b68fa3c617123b.svg";


//////////////////
// WEBPACK FOOTER
// ./sass/navbar/logo.svg
// module id = 1022
// module chunks = 0